"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RESET_MODAL_STATE = exports.FETCH_CLIENT_APPLICATION_FAILURE = exports.CREATE_CONTRACT_SUCCESS = exports.CREATE_CONTRACT_REQUEST = exports.CREATE_CONTRACT_FAILURE = exports.CREATE_CLIENT_APPLICATION_SUCCESS = exports.CREATE_CLIENT_APPLICATION_REQUEST = exports.CREATE_CLIENT_APPLICATION_FAILURE = void 0;
var RESET_MODAL_STATE = exports.RESET_MODAL_STATE = 'Reset Request Access Modal state';
var CREATE_CONTRACT_REQUEST = exports.CREATE_CONTRACT_REQUEST = 'Create contract request';
var CREATE_CONTRACT_SUCCESS = exports.CREATE_CONTRACT_SUCCESS = 'Create contract success';
var CREATE_CONTRACT_FAILURE = exports.CREATE_CONTRACT_FAILURE = 'Create contract failure';
var CREATE_CLIENT_APPLICATION_REQUEST = exports.CREATE_CLIENT_APPLICATION_REQUEST = 'Create client application request';
var CREATE_CLIENT_APPLICATION_SUCCESS = exports.CREATE_CLIENT_APPLICATION_SUCCESS = 'Create client application success';
var CREATE_CLIENT_APPLICATION_FAILURE = exports.CREATE_CLIENT_APPLICATION_FAILURE = 'Create client application failure';
var FETCH_CLIENT_APPLICATION_FAILURE = exports.FETCH_CLIENT_APPLICATION_FAILURE = 'Fetch client application failure';
//# sourceMappingURL=actionTypes.js.map